import * as Sentry from "@sentry/browser";

function baseSentryConfig(sentryEnv, gitRevision) {
  return {
    dsn: "https://740bcc91986f1f684ba80fbd888a8069@o4509050159562752.ingest.de.sentry.io/4509050162577488",
    environment: sentryEnv,
    release: gitRevision,
    transport: Sentry.makeBrowserOfflineTransport(Sentry.makeFetchTransport),
    enableLogs: true,
  };
}

function browserSentryConfig(sentryEnv, gitRevision) {
  return {
    ...baseSentryConfig(sentryEnv, gitRevision),
    integrations: [
      Sentry.browserTracingIntegration({
        tracingOrigins: [location.hostname],
        enableLongTask: true,
        instrumentNavigation: true,
        instrumentPageLoad: true,
        enableInp: true,
      }),
    ],
    tracesSampleRate: 1.0,
    beforeSend(event) {
      if ("serviceWorker" in navigator) {
        event.contexts = event.contexts || {};
        event.contexts.pwa = {
          standalone: window.matchMedia("(display-mode: standalone)").matches,
          serviceWorkerActive: navigator.serviceWorker.controller !== null,
        };
      }
      return event;
    },
    beforeSendTransaction(transaction) {
      const duration = transaction.timestamp - transaction.start_timestamp;
      if (duration < 0.01) return null;

      if (transaction.transaction?.includes("?")) {
        transaction.transaction = transaction.transaction.split("?")[0];
      }

      return transaction;
    },
  };
}

function workerSentryConfig(sentryEnv, gitRevision) {
  return {
    ...baseSentryConfig(sentryEnv, gitRevision),
  };
}

function isEnabled(sentryEnabled) {
  if (typeof sentryEnabled === "boolean") return sentryEnabled;
  if (typeof sentryEnabled === "string") return sentryEnabled === "true";
  if (sentryEnabled && typeof sentryEnabled === "object") {
    return sentryEnabled.value === true;
  }
  return false;
}

function getEnv(sentryEnv) {
  if (typeof sentryEnv === "string") return sentryEnv;
  if (sentryEnv && typeof sentryEnv === "object") {
    return sentryEnv.value;
  }
  return undefined;
}

export function initSentry(sentryEnabled, sentryEnv, gitRevision, runtime = "browser") {
  if (!isEnabled(sentryEnabled)) return;

  const config =
    runtime === "worker"
      ? workerSentryConfig(getEnv(sentryEnv), gitRevision)
      : browserSentryConfig(getEnv(sentryEnv), gitRevision);
  Sentry.init(config);
}
